import React, { useEffect, useRef, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import Modal from "../../components/common/Model";
import TableLayout from "../../components/layouts/table-layout";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../hooks/routes/routes-constant";
import { DOCTOR_DETAIL_IAMGE, PROFILE_IMG } from "../../utils/aap-image-constant";
import { useNavigate } from "react-router-dom";
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
import { decryptAEStoJSON, EllipsisWithTooltip, toastEmitter } from "../../utils/utilities";
import { useSelector } from "react-redux";
import { myPatientList } from "../../hooks/services/api-services";
import AccessPermissionpage from "../../components/common/accessPermissionpage";
import { API_URL } from "../../utils/url-constants";

const Patient = () => {
  const { t ,i18n} = useTranslation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const addbuttonClick = useRef();
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const [rowData, setRowData] = useState([]);
  const isFirstRender = useRef(true);
  const hasShownErrorToast = useRef(false);

  // patient list
  const payload = {
    pageIndex: searchTerm === "" ? page || 0 : 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    searchText: searchTerm,
    direction: sortDirection || "desc",
    filterByFieldName: sortColumn || "id",
    status: 0,
    clinicId: userData?.id,
    languageType:i18n.language
  };

  const fetchPatientList = async () => {
    setPending(true);
    try {
      const response = await myPatientList(payload);
      if (response?.data?.status !== 200) {
        setRowData([]);
      } else {
        setRowData(response?.data?.data?.patientResponseList);
        setTotalRows(response?.data?.data?.totalElement);
        hasShownErrorToast.current = false; // Reset on success
      }
    } catch (err) {
      if (!isFirstRender.current && !hasShownErrorToast.current) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
        hasShownErrorToast.current = true;
      }
    } finally {
      setPending(false);
      isFirstRender.current = false; // After first attempt
    }
  };

  useEffect(() => {
    if (userData?.id) {
      fetchPatientList();
    }
  }, [page, pageSize, searchTerm, sortDirection, sortColumn, userData?.id,i18n.language]);

  const tableColumns = [
    {
      name: t("S.No"),
      width: "100px",
      selector: (row, i) => i + 1,
    },
    {
      name: t("Patient Name"),
      code: "fullName",
      width: "150px",
      sortable: true,
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center fw-600 fs-12 ">
          <div
            className="rounded-circle overflow-hidden rounded-circle"
          >
            <img
              src={row?.image ? `${API_URL?.ServerURL}${row?.image}` : PROFILE_IMG}
              alt=""
              style={{
                objectFit: "cover", objectPosition: "center", width: "32px",
                height: "32px",
              }}

            />
          </div>

          {row?.fullName}
        </div>
      ),
    },
    {
      name: t("E-mail"),
      width: "200px",
      sortable: true,
      selector: (row) =>
      (
        <EllipsisWithTooltip text={`${row.email || "N/A"}`} maxWidth="250px" />
      )
    },
    {
      name: t("Mobile Number"),
      width: "170px",
      sortable: true,
      cell: (row) => {
        return <>{`${row?.code} ${row?.mobileNo}`}</>;
      },
    },
    {
      name: t("Date"),
      selector: (row) => row?.createdDate?.slice(0, 10),
    },
    {
      name: t("Time"),
      selector: (row) => row?.createdDate.slice(11, 16),
    },
    {
      id: "detail",
      name: t("Detail"),
      cell: (row) => (
        <button
          className="border-0 bg-white"
          onClick={() => {
            navigatePatientAppointment(row);
          }}
        >
          <img src={DOCTOR_DETAIL_IAMGE} alt="View" className="editicon ms-2" />
        </button>
      ),
    },
  ];

  const navigatePatientAppointment = (row) => {
    navigate(
      `${ROUTES?.PATIENT}/patientAppointment/${row?.fullName
        .toLowerCase()
        .replaceAll(" ", "-")}`,
      { state: { patientId: row?.id } }
    );
  };

  // permission code for this module start
  const [permissionAccess, setPermissionAccess] = useState();
  const rawPermission = useSelector((state) => state?.permission?.value);
  const permissions = decryptAEStoJSON(rawPermission);
  useEffect(() => {
    const RoleAccessFilterData =
      permissions &&
      permissions?.filter((v) => v.moduleName === "Patient Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, []);
  // permission code for this module end
  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <div className="main_datatable my-lg-3 my-2">
          <TableHeading
            title={t("Patient Management")}
            searchValue={searchTerm}
            setSearchValue={setSearchTerm}
            showbutton={false}
          />

          <div className="table-wrapper">
            <TableLayout
              _tblColumns={tableColumns}
              _rowData={rowData}
              pending={pending}
              pagination={true}
              selectableRows={false}
              setPending={setPending}
              _totalRows={totalRows}
              pageSize={pageSize}
              setPageSize={setPageSize}
              setPage={setPage}
              setSortColumn={setSortColumn}
              setSortDirection={setSortDirection}
            />
          </div>
          <Modal
            modalId="patientlist"
            modalClick={addbuttonClick}
            paragraph="Doctor Added Successfully. You Can Manage it From Doctor Management Section."
            heading="Doctor Added Sucessfully"
          ></Modal>
        </div>
      )}
    </>
  );
};
export default Patient;
